export default __webpack_public_path__ + "static/media/chevron-down.ad422895.svg";